import React, { useState } from 'react'
import EconomicAssetBookingModalDetails from './economic-asset-booking-details'
import { ModalBig } from '@/modules/base/components/modal'
import lang from '@/lang'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import CheckIcon from '@assets/images/icons/check.svg'
import { EconomicAssetService } from '@/modules/economicAsset/economicAssetService'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { refreshList } from '@/redux/ducks/economicAsset/list'
import { dispatch } from '@/redux/ducks/lists'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import { makeStyles } from '@mui/styles'
import { ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP } from '@/modules/economicAsset/constants'

const useStyles = makeStyles(theme => ({
  tooltipWrapper: {
    height: 'fit-content',
    color: theme.black,
  },
  tooltipTitle: {
    paddingBottom: '20px',
    textAlign: 'left',
    fontSize: theme.fontSizes.default,
    lineHeight: '20px',
    color: theme.black,
    fontWeight: theme.fontWeights.bold,
  },
  tooltipContent: {
    fontSize: theme.fontSizes.smaller,
  },
}))

interface EconomicAssetBookingModalProps {
  open: boolean;
  onClose: () => void;
  dateOfPurchase: string;
  economicAssetId: number,
  onRefresh: () => void
}

const EconomicAssetBookingModal: React.FC<EconomicAssetBookingModalProps> = (props) => {
  const {
    open,
    onClose,
    dateOfPurchase,
    economicAssetId,
    onRefresh,
  } = props
  const classes = useStyles()
  const [formValues, setFormValues] = useState<{ type: string, date: string | null, comments: string, vatPercent: number, priceGross: number }>()
  const validateSubmitButton = !formValues?.date
  || (formValues.type === ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.SALE && (!formValues?.date || !formValues?.priceGross))

  const handleFormValuesChange = (values: { type: string, date: string | null, comments: string, vatPercent: number, priceGross: number }) => {
    if (values.type === ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.LOSS_OR_DESTRUCTION) {
      setFormValues({
        ...values,
        vatPercent: null,
        priceGross: null,
      })
    } else {
      setFormValues(values)
    }
  }

  const tooltipButton = (<div className={classes.tooltipWrapper}>
    <div className={classes.tooltipTitle}>{lang.economicAsset.bookingModal.submitButtonTooltipTitle}</div>
    <div className={classes.tooltipContent} dangerouslySetInnerHTML={{ __html: lang.economicAsset.bookingModal.submitButtonTooltipDescription }} />
  </div>
  )

  const handleSubmit = async() => {
    try {
      await EconomicAssetService.addSpecialDeprecation(economicAssetId, formValues)
      toast.showToast({ message: lang.economicAsset.toast.bookingSuccess })
      onClose()
      onRefresh()
      dispatch(refreshList())
    } catch (error) {
      toast.showToast({ type: 'error', message: lang.economicAsset.toast.bookingError })
    }
  }

  const actions = [
    <CancelButton
      type='cancel'
      label={lang.cancelButtonLabel}
      onClick={onClose} />,
    <RichTooltip content={tooltipButton} width={300} placement={'top'} disabled={!validateSubmitButton}>
      <div>
        <ButtonIconSquare
          type='submit'
          icon={CheckIcon}
          label={lang.economicAsset.bookingModal.submitButton}
          onClick={handleSubmit}
          disabled={validateSubmitButton}
        />
      </div>
    </RichTooltip>,
  ]
  return (
    <div>
      <ModalBig
        title={lang.economicAsset.bookingModal.title}
        disableEscapeKeyDown
        disableBackdropClick
        showCloseIcon
        open={open}
        onClose={onClose}
        actions={actions}
      >
        <EconomicAssetBookingModalDetails
          dateOfPurchase={dateOfPurchase}
          onValuesChange={handleFormValuesChange} />
      </ModalBig>
    </div>

  )
}

export default EconomicAssetBookingModal
